// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 999 ? "f31aec94" : chunkId) + "." + {"724":"b6e969cd1740e197","999":"ec56de3f7b4f55a1"}[chunkId] + ".js";
};